export const CASH_FORECAST_USER_IDS = new Set([1, 4, 34, 68, 1672]);

export const canAccessCashForecast = (user) => CASH_FORECAST_USER_IDS.has(user?.id);
